import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import classnames from 'classnames';
// import { getString, isPhone, isiPad } from '../../pages/utils';
import * as styles from './dialog.module.scss';
import { TenantContext, UserContext, DeviceType } from '../../../orbit-context';

export const isPhone = () => {
  let _isPhone = false;

  const ua = window.navigator.userAgent;
  const isIOS = (((((((((((((((((((((((((((((((((((((((((/iPhone|iPad/i))))))))))))))))))))))))))))))))))))))))).test(ua) && !window['x5mtt'];

  let isiPhone = isIOS && (((((((((((((((((((((((((((((((((((((((((/iPhone/i))))))))))))))))))))))))))))))))))))))))).test(ua);
  let isiPad = isIOS && (((((((((((((((((((((((((((((((((((((((((/iPad/i))))))))))))))))))))))))))))))))))))))))).test(ua) &&
    (screen.width * screen.height === 1024 * 768 ||
      (Math.round(screen.width / screen.height * 1000) / 1000 > 1.330 && Math.round(screen.width / screen.height * 1000) / 1000 < 1.340) ||
      (Math.round(screen.height / screen.width * 1000) / 1000 > 1.330 && Math.round(screen.height / screen.width * 1000) / 1000 < 1.340)
    );

  const screenResolutionCheck1 = (Math.round(screen.width / screen.height * 1000) / 1000) === 0.667;
  const screenResolutionCheck2 = (Math.round(screen.height / screen.width * 1000) / 1000) === 1.5;
  if (isiPhone && screenResolutionCheck1 && screenResolutionCheck2) {
    // fixed for iPad Pro 12.9 inch
    isiPhone = false;
    isiPad = true;
  }

  const isAndroid = window['x5mtt'] || (((((((((((((((((((((((((((((((((((((((((/Android/i))))))))))))))))))))))))))))))))))))))))).test(ua);
  const isAndroidPad = (window['x5mtt'] || (((((((((((((((((((((((((((((((((((((((((/Android/i))))))))))))))))))))))))))))))))))))))))).test(ua)) &&
    (Math.min(screen.height, screen.width) >= 600 &&
      (Math.max(screen.height, screen.width) / Math.min(screen.height, screen.width) > 1.5));

  const isWeChat = (((((((((((((((((((((((((((((((((((((((((/micromessenger/i))))))))))))))))))))))))))))))))))))))))).test(ua);

  if (((isiPhone && !isiPad) || (isAndroid && !isAndroidPad)) && document.documentElement.clientWidth < 751 || isWeChat && document.documentElement.clientWidth < 751) {
    _isPhone = true;
  }

  return _isPhone;
};

export const isiPad = () => {
  let _isiPad = false;

  const ua = window.navigator.userAgent;
  const isIOS = (((((((((((((((((((((((((((((((((((((((((/iPhone|iPad/i))))))))))))))))))))))))))))))))))))))))).test(ua) && !window['x5mtt'];

  let isiPhone = isIOS && (((((((((((((((((((((((((((((((((((((((((/iPhone/i))))))))))))))))))))))))))))))))))))))))).test(ua);
  _isiPad = isIOS && (((((((((((((((((((((((((((((((((((((((((/iPad/i))))))))))))))))))))))))))))))))))))))))).test(ua) &&
    (screen.width * screen.height === 1024 * 768 ||
      (Math.round(screen.width / screen.height * 1000) / 1000 > 1.330 && Math.round(screen.width / screen.height * 1000) / 1000 < 1.340) ||
      (Math.round(screen.height / screen.width * 1000) / 1000 > 1.330 && Math.round(screen.height / screen.width * 1000) / 1000 < 1.340)
    );

  const screenResolutionCheck1 = (Math.round(screen.width / screen.height * 1000) / 1000) === 0.667;
  const screenResolutionCheck2 = (Math.round(screen.height / screen.width * 1000) / 1000) === 1.5;
  if (isiPhone && screenResolutionCheck1 && screenResolutionCheck2) {
    // fixed for iPad Pro 12.9 inch
    isiPhone = false;
    _isiPad = true;
  }

  return _isiPad;
};

export const getProductData = (data, config) => {
  const features = (function () {
    const cfg = config?.[data?.feature?.[0]?.referenceFeatureSystemName];
    if (config && data && Array.isArray(data?.feature?.[0]?.features)) {
      console.log('data?.feature[0].features = ', data?.feature[0].features);
      return data?.feature[0].features.map(item => {
        const label = cfg.features[String(item.frIdref)] ?? item.fref;
        const value = (typeof (item.fvalue) === 'boolean' ? (item.fvalue ? '有' : '无') : item.fvalue) ?? cfg.fValues[String(item.valueIdRef)];
        return ({ label, value: `${value} ${item?.unitCode ?? ''}`, visible: item?.showAble });
      });
    } else {
      return [];
    }
  })();

  const images = (function () {
    const parse = (i) => ({ type: 'image', thumbnail: i?.['mimeSource']?.[0]?.['#text'], data: i?.['mimeSource']?.[0]?.['#text'] });
    if (data?.mime?.length > 0) {
      const normal = data.mime.filter(d => d.mimePurpose === 'normal');
      return (normal?.length > 0 ? normal : data.mime.filter(d => d.mimePurpose === 'thumbnail'))?.map(parse);
    } else {
      return [{ mimeSource: [{ '#text': '/images/dproduct.svg' }] }]?.map(parse);
    }
  })();

  const medias = (function () {
    const parse = (i) => ({ type: 'video', data: i?.['mimeSource']?.[0]?.['#text'], thumbnail: images[0].thumbnail });
    if (data?.mime?.length > 0) {
      const dataSheet = data.mime.filter(d => d.mimePurpose === 'data_sheet');
      return dataSheet?.map(parse).filter(i => i?.data?.endsWith('.mp4'));
    } else {
      return [];
    }
  })();

  const threes = (function () {
    const parse = (i) => ({ type: '3d', data: i?.['mimeSource']?.[0]?.['#text'], thumbnail: '/images/product.svg' });
    if (data?.mime?.length > 0) {
      const dataSheet = data.mime.filter(d => d.mimePurpose === 'data_sheet');
      return dataSheet?.map(parse).filter(i => i?.data?.endsWith('.gltf'));
    } else {
      return [];
    }
  })();

  // const name = data?.details?.descriptionShort?.zh;
  const name = data?.name?.zh;
  return {
    data,
    name,
    medias,
    features,
    images,
    threes
  };
};

class Dialog extends Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      scale: false
    };
  }

  entranceClicked = (target) => {
    const { history, match} = this.props;
    const prefix = 'products';

    if (target.id === undefined) return;
    console.log('history ========>>>', history);
    history.push(`/productdetail/${target.id}`);
  }

  render() {
    const { className, data, style, config } = this.props;
    console.log('data ======>', data);
    return (
      <div style={style} className={classnames(className, styles.dialog_component, isiPad() && styles.isiPad, isPhone() && styles.isPhone, window.orbitBridge && styles.fixedUI)}>
        <div className={styles.mask}
          onClick={event => this.props.onDialogClose()}></div>
        <div className={styles.dialog_content}>
          <div className={styles.close_btn}
            onClick={event => this.props.onDialogClose()}><i className={'iconfont'}>&#xe64e;</i></div>
          <div className={styles.scrolling_content}>
            <div className={classnames(styles.item, styles.item0)}>
              <div className={styles.title}>{data?.a_name}</div>
              {data.info && data.info.length ?
                <div
                  className={styles.desc_content}
                  dangerouslySetInnerHTML={{ __html: data.info }} />
                :
                <div className={styles.desc_content}>{'暂无内容'}</div>
              }
            </div>
            {data?.product_ids?.length > 0 &&
              <div className={classnames(styles.item, styles.item1)}>
                <div className={styles.title}>{'相关产品'}</div>
                <div className={styles.item_lists}>
                  {
                    data?.productInfo?.map((rp, index) => {
                      // if (!rp._id || !rp.name) return;

                      // let title = '';
                      // let subTitle = '';
                      // if (rp.name.indexOf('(') > -1) {
                      //   title = rp.name.split('(')[0];
                      //   subTitle = '(' + rp.name.split('(')[1];
                      // } else if (rp.name.indexOf('（') > -1) {
                      //   title = rp.name.split('（')[0];
                      //   subTitle = '(' + rp.name.split('（')[1];
                      // }
                      console.log('rp ====>>', rp, config);
                      const { name, images } = getProductData(rp, config);
                      console.log('parseData ====>>', images);
                      return (
                        <div key={index}
                          className={classnames(styles.list_item, !(index % 2) && styles.odd)}
                        >
                          <div className={styles.cover}
                            style={{ 
                              backgroundImage: `url(${images?.[0]?.thumbnail})`, 
                              backgroundRepeat: 'no-repeat',
                              backgroundPositionX: 'center',
                              backgroundPositionY: 'center',
                              backgroundSize: 'contain' }}></div>
                          <div className={styles.title0}>
                            <div className={styles.name}>{name}</div>
                            {/* <div className={styles.name}>{name}</div> */}
                            <div className={styles.entrance}>
                              <span onClick={() => this.entranceClicked(rp)}>查看详情<i className={'iconfont'}>&#xe64f;</i></span>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              </div>
            }
          </div>
        </div>
        {
          this.state.scale ?
            <div className={styles.scale} onClick={() => {
              this.setState({ scale: false });
            }}>
              <img className={styles.scaleImage} src={this.state.imageUrl} />
            </div>
            : null
        }
      </div>
    );
  }
}

export default withRouter(Dialog);